import { render } from "./Solution.vue?vue&type=template&id=2b6a175c"
import script from "./Solution.vue?vue&type=script&lang=js"
export * from "./Solution.vue?vue&type=script&lang=js"

import "./Solution.vue?vue&type=style&index=0&id=2b6a175c&lang=css"
script.render = render

export default script